const REP_ONLY_GROUPS = new Set(['Opener', 'Closer']);
/** REG-922: the email marketing partner's role. His sidebar is the partner leads page only. */
export const INSTANTLY_PARTNER_GROUP = 'Instantly Partner';

export interface RepOnlyNavigationState {
  isRepOnly: boolean;
  repId: number | null;
  repLinkStatus: 'available' | 'missing' | 'multiple' | 'not-applicable';
  /** Every group the user is in is Instantly Partner. */
  isInstantlyPartner: boolean;
}

export function deriveRepOnlyNavigation(
  groupNames: string[],
  repIds: number[],
): RepOnlyNavigationState {
  const uniqueGroups = [...new Set(groupNames)];
  const isInstantlyPartner = uniqueGroups.length > 0
    && uniqueGroups.every((name) => name === INSTANTLY_PARTNER_GROUP);
  const isRepOnly = uniqueGroups.length > 0
    && uniqueGroups.every((name) => REP_ONLY_GROUPS.has(name));

  if (!isRepOnly) {
    return { isRepOnly: false, repId: null, repLinkStatus: 'not-applicable', isInstantlyPartner };
  }

  const uniqueRepIds = [...new Set(repIds)];
  if (uniqueRepIds.length === 0) {
    return { isRepOnly: true, repId: null, repLinkStatus: 'missing', isInstantlyPartner };
  }
  if (uniqueRepIds.length > 1) {
    return { isRepOnly: true, repId: null, repLinkStatus: 'multiple', isInstantlyPartner };
  }
  return { isRepOnly: true, repId: uniqueRepIds[0], repLinkStatus: 'available', isInstantlyPartner };
}
